module.exports = __webpack_public_path__ + "static/img/8-1.38aa8e51.jpg";